import assign from 'lodash/assign';
import reportError from '../tracking/errorReporter';

export class ScriptLoader {
  constructor() {
    this.loaded = new Set();
  }

  addToCache = (scriptUrl) => {
    this.loaded.add(scriptUrl);
  }

  hasScript = scriptUrl => this.loaded.has(scriptUrl);

  createScriptTag = (tag, url, callback) => {
    const attributes = {
      type: 'text/javascript',
      defer: true,
      src: url,
      onerror: () => reportError(`Could not load script ${url}`),
      onload: () => {
        this.addToCache(url);
        callback();
      },
    };

    return assign(tag, attributes);
  };

  injectTag = tag => document.body.appendChild(tag);

  loadScript = (scriptUrl, callback = () => {}) => {
    if (!this.hasScript(scriptUrl)) {
      const scriptTag = document.createElement('script');
      const scriptTagWithAttributes = this.createScriptTag(scriptTag, scriptUrl, callback);

      this.injectTag(scriptTagWithAttributes);
    }
  }
}

export default new ScriptLoader();
